export const DictEnum = {
    ActivityType: "001",
    VenueType: "002",
    ProductType: "003",
    PoliticalityType: "004"
};

export const GlobalSettingsEnum = {
    ACTIVITY_AllowHoursSignInBeforeStart: 2,
    ACTIVITY_AllowHoursGiveUpBeforeStart: 24
};

export const IntegralExchangeStateEnum = {
    Unapproved: 1,
    Approved: 2,
    Rejected: -1
};

export const RealVerifyStateEnum = {
    Unapproved: 1,
    Approved: 2,
    Rejected: -1
};

export const FavoritesTypeEnum = {
    Activity: 1,
    Venue: 2,
    Product: 3
};

export const NotesTypeEnum = {
    Activity: 1
};

export const ActivityStateEnum = {
    Unapproved: 1,
    Approving: 2,
    Approved: 3,
    Rejected: -3
};

export const ActivityMemberStateEnum = {
    Unapproved: 1,
    Approving: 2,
    Approved: 3,
    Rejected: -3
};

export const ScreenColorTheme = {
    lightPink: {
        name: "浅粉",
        bgColor: "#EEA6A9",
        titleBolderColor: "#F17D97",
        bodyBolderColor: "#EC899B",
        imgBolderColor: "#EB7D92",
        fontColor: "#E75B79",
        fontBgColor: "#FBEAEB",
        darkTitleColor: "#E75B79",
        lightTitleColor: "#F489A0",
        contentBgColor: "#FDF6F7",
        fontBoldColor: "#EE758F"
    },
    lightYellow: {
        name: "浅黄",
        bgColor: "#EAD15B",
        titleBolderColor: "#EBCA31",
        bodyBolderColor: "#F8C551",
        imgBolderColor: "#FEC047",
        fontColor: "#FFBA39",
        fontBgColor: "#FAF4D9",
        darkTitleColor: "#FFB731",
        lightTitleColor: "#FFC964",
        contentBgColor: "#FDFAEF",
        fontBoldColor: "#EDCE3B"
    },
    lightBlue: {
        name: "浅蓝",
        bgColor: "#8AD1EE",
        titleBolderColor: "#2F82C6",
        bodyBolderColor: "#559CD2",
        imgBolderColor: "#5BA1D4",
        fontColor: "#3B89C8",
        fontBgColor: "#E4F4FB",
        darkTitleColor: "#2E81C5",
        lightTitleColor: "#5AA7DD",
        contentBgColor: "#F4FBFD",
        fontBoldColor: "#2F82C5"
    },
    lightGreen: {
        name: "浅绿",
        bgColor: "#A4CD57",
        titleBolderColor: "#7AA42A",
        bodyBolderColor: "#75BB66",
        imgBolderColor: "#70BB70",
        fontColor: "#2A6E34",
        fontBgColor: "#EAF3D8",
        darkTitleColor: "#87B630",
        lightTitleColor: "#A8D454",
        contentBgColor: "#F7FAF0",
        fontBoldColor: "#82AC31"
    },
    lightPurple: {
        name: "浅紫",
        bgColor: "#A9A1D0",
        titleBolderColor: "#6A5ABB",
        bodyBolderColor: "#AA9EE2",
        imgBolderColor: "#AC9FE4",
        fontColor: "#A376F0",
        fontBgColor: "#EDE6F9",
        darkTitleColor: "#7161AE",
        lightTitleColor: "#948CD2",
        contentBgColor: "#F7F6FB",
        fontBoldColor: "#6B5ABC"
    },
    darkYellow: {
        name: "深黄",
        bgColor: "#F7C167",
        titleBolderColor: "#FFA544",
        bodyBolderColor: "#FBAD63",
        imgBolderColor: "#FCAC63",
        fontColor: "#FF9049",
        fontBgColor: "#FDF1DC",
        darkTitleColor: "#FF9F49",
        lightTitleColor: "#FFC154",
        contentBgColor: "#FEF9F1",
        fontBoldColor: "#FFA544"
    },
    darkBlue: {
        name: "深蓝",
        bgColor: "#88A7D5",
        titleBolderColor: "#4276C4",
        bodyBolderColor: "#4A7ABA",
        imgBolderColor: "#4577B7",
        fontColor: "#1754A5",
        fontBgColor: "#E3EAF5",
        darkTitleColor: "#4D7EC7",
        lightTitleColor: "#719AD8",
        contentBgColor: "#F3F6FB",
        fontBoldColor: "#4679C5"
    },
    darkPink: {
        name: "浅红",
        bgColor: "#E84848",
        titleBolderColor: "#EB6885",
        bodyBolderColor: "#E84A4B",
        imgBolderColor: "#E84848",
        fontColor: "#E75D7B",
        fontBgColor: "#FBDCDC",
        darkTitleColor: "#F24D4D",
        lightTitleColor: "#F06D6D",
        contentBgColor: "#FDEDED",
        fontBoldColor: "#F2829A"
    }
};